import { type IconProp, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fass } from '@fortawesome/sharp-solid-svg-icons';
import type { IHeaderGroupParams } from 'ag-grid-enterprise';

library.add(fass);

export type ICustomHeaderGroupParams = {
  icon: string;
};

const HeaderGroupWithIcon = (params: ICustomHeaderGroupParams & IHeaderGroupParams) => {
  const { displayName, icon } = params;

  if (!icon) {
    return (
      <div className="w-full text-center">
        <span>{displayName}</span>
      </div>
    );
  }

  // @ts-expect-error adding by instruction of https://docs.fontawesome.com/web/use-with/react/add-icons
  const myIcon: IconProp = ['fa-sharp', icon];

  return (
    <div className="w-full text-center">
      <FontAwesomeIcon
        className="mr-2"
        icon={myIcon}
      />
      <span>{displayName}</span>
    </div>
  );
};

export default HeaderGroupWithIcon;
